/* eslint-disable import/no-extraneous-dependencies -- for history. */
import { History, Transition } from 'history';
import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

type ExtendNavigator = Navigator & Pick<History, 'block'>;

/**
 * `useBlocker` is not part of react-router-dom v6 at the moment.
 * [source]{@link https://gist.github.com/rmorse/426ffcc579922a82749934826fa9f743}
 * [issue]{@link https://github.com/remix-run/react-router/issues/8139}
 */
export const useBlocker = (blocker: (tx: Transition) => void, queryBlocker: (tx: Transition) => void, when = true) => {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return () => null;

    const unblock = (navigator as any as ExtendNavigator).block((tx) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblock();
          tx.retry();
        },
      };

      const { pathname: currentPathName, search: currentSearch } = (navigator as History).location;
      const { pathname: newPathName, search: newSearch } = tx.location;
      if (currentPathName === newPathName && currentSearch !== newSearch) {
        queryBlocker(autoUnblockingTx);
        return;
      }

      blocker(autoUnblockingTx);
    });

    return unblock;
  }, [navigator, blocker, queryBlocker, when]);
};
